module.exports = __webpack_public_path__ + "static/media/gaucher2.dd80e439.jpg";